"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSuppliers = exports.getItems = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _helpers = require("../../../../helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CancelToken = _axios["default"].CancelToken;
var cancel;

var getItems = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref) {
    var query, suppliers, location, config, env, setCurSupplier, setAllItems, cancelToken, allItems;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = _ref.query, suppliers = _ref.suppliers, location = _ref.location, config = _ref.config, env = _ref.env, setCurSupplier = _ref.setCurSupplier, setAllItems = _ref.setAllItems;
            if (cancel) cancel();
            cancelToken = new CancelToken(function (token) {
              return cancel = token;
            });
            allItems = [];
            _context2.next = 6;
            return suppliers.forEach( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(supplier) {
                var currentCat, searchUrl, storeCode, result, updatedSupplier;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        currentCat = config.categories.find(function (category) {
                          return category.name.toLowerCase() === query.term.toLowerCase().replace('%20', ' ');
                        });
                        searchUrl = null;

                        if (currentCat.queries) {
                          searchUrl = currentCat.queries[supplier.Id] || null;
                        } else if (currentCat.rootQueries) {
                          searchUrl = currentCat.rootQueries[supplier.Id].url || null;
                        }

                        storeCode = location ? location.StoreCode : undefined;
                        _context.next = 6;
                        return (0, _helpers.getSearchItems)({
                          query: query,
                          config: config,
                          id: supplier.Id,
                          accountNumber: supplier.AccountNumber,
                          storeCode: storeCode,
                          searchUrl: searchUrl,
                          env: env,
                          cancelToken: cancelToken
                        });

                      case 6:
                        result = _context.sent;
                        updatedSupplier = _objectSpread({}, supplier);
                        updatedSupplier.items = result.fetchedData ? result.fetchedData : null;
                        updatedSupplier.itemsAvailable = false;
                        updatedSupplier.itemsReturned = !result.fetchError && result.fetchedData && !_lodash["default"].isEmpty(result.fetchedData.PartList);
                        if (updatedSupplier.itemsReturned) result.fetchedData.PartList.forEach(function (item) {
                          if (item.IsAvailable) updatedSupplier.itemsAvailable = true;
                        });
                        setCurSupplier(updatedSupplier);

                        if (_lodash["default"].has(result, 'fetchedData.PartList') && _lodash["default"].isArray(result.fetchedData.Partlist) && !_lodash["default"].isEmpty(result.fetchedData.PartList)) {
                          allItems = allItems.concat(result.fetchedData.PartList.map(function (item) {
                            return _objectSpread(_objectSpread({}, item), {}, {
                              supplier: updatedSupplier
                            });
                          }));
                        }

                        setAllItems(allItems);

                      case 15:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getItems(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getItems = getItems;

var updateSuppliers = function updateSuppliers(_ref4) {
  var supplier = _ref4.supplier,
      suppliers = _ref4.suppliers,
      setSuppliers = _ref4.setSuppliers,
      isAvailable = _ref4.isAvailable;
  var id = supplier.Id;
  var arr = [];
  suppliers.forEach(function (sup) {
    return sup.itemsReturned && sup.itemsAvailable && !_lodash["default"].includes(arr, sup) && arr.push(sup);
  });
  suppliers.forEach(function (sup) {
    if (sup.Id === id && !_lodash["default"].includes(arr, sup) && supplier.itemsReturned && supplier.itemsAvailable) {
      arr.push(supplier);
    }
  });
  suppliers.forEach(function (sup) {
    return (!sup.itemsReturned || !sup.itemsAvailable) && !_lodash["default"].includes(arr, sup) && sup.Id !== id && arr.push(sup);
  });
  suppliers.forEach(function (sup) {
    if (sup.Id === id && !_lodash["default"].includes(arr, sup) && (!supplier.itemsReturned || !supplier.itemsAvailable)) {
      arr.push(supplier);
    }
  });
  setSuppliers(arr);
};

exports.updateSuppliers = updateSuppliers;